import { adminFetch } from "./_client";
import type { FraudCaseRow, FraudCaseEntity, FraudCaseAction } from "./types";


export function listFraudCases(token: string, params: { status?: string; q?: string; limit?: number; offset?: number } = {}) {
  const sp = new URLSearchParams();
  if (params.status) sp.set("status", params.status);
  if (params.q) sp.set("q", params.q);
  if (params.limit) sp.set("limit", String(params.limit));
  if (params.offset) sp.set("offset", String(params.offset));
  const qs = sp.toString();
  return adminFetch<{ rows: FraudCaseRow[]; total: number; limit: number; offset: number }>(`/admin/fraud-cases${qs ? `?${qs}` : ""}`, token);
}

export function getFraudCase(token: string, id: number) {
  return adminFetch<{ case: FraudCaseRow; entities: FraudCaseEntity[]; actions: FraudCaseAction[] }>(`/admin/fraud-cases/${id}`, token);
}

export function createFraudCase(token: string, body: { summary?: string; primary_user_id?: string; entities?: Array<{ entity_type: string; entity_id: string | number; note?: string }>; note?: string }) {
  return adminFetch<{ case: FraudCaseRow }>(`/admin/fraud-cases`, token, { method: "POST", body: JSON.stringify(body) });
}

export function attachFraudEntity(token: string, caseId: number, body: { entity_type: string; entity_id: string | number; note?: string }) {
  return adminFetch<{ entity: FraudCaseEntity }>(`/admin/fraud-cases/${caseId}/entities`, token, { method: "POST", body: JSON.stringify(body) });
}

export function detachFraudEntity(token: string, caseId: number, entityId: number) {
  return adminFetch<{ ok: true }>(`/admin/fraud-cases/${caseId}/entities/${entityId}`, token, { method: "DELETE" });
}

export function setFraudVerdict(token: string, caseId: number, body: { verdict: "block" | "review" | "cleared"; notes?: string }) {
  return adminFetch<{ case: FraudCaseRow }>(`/admin/fraud-cases/${caseId}/verdict`, token, { method: "POST", body: JSON.stringify(body) });
}
